<template>
  <div>
    <DetailDialog v-if="showDialog" @emitShow="DetailButtonClose" />
  </div>
</template>

<script>
import DetailDialog from '@/components/payments/DetailDialog.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    DetailDialog,
  },
  data() {
    return {
      showDialog: true,
      payment: null,
      wholesalerId: null,
    }
  },
  async created() {},
  methods: {
    ...mapActions('bnpl', ['getPaymentsDetail']),
    DetailButtonClose(result) {
      this.showDialog = result
      this.$router.go(-1)
    },
  },
}
</script>
